import { render, staticRenderFns } from "./PedidosItem.vue?vue&type=template&id=3e2f759b&scoped=true"
import script from "./PedidosItem.vue?vue&type=script&lang=js"
export * from "./PedidosItem.vue?vue&type=script&lang=js"
import style0 from "./PedidosItem.vue?vue&type=style&index=0&id=3e2f759b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2f759b",
  null
  
)

export default component.exports